import { useEffect, useState } from "react";
import styled from "styled-components";
import MainLayout from "../../layouts/mainLayout/mainLayout";
import Menus from "../../components/hamburger/menus";
import HamburgerLay from "../../components/hamburger/hamburger";
import { Colors } from "../../utilities/colors";
import * as Mui from "@material-ui/core";
import CvCard from "../../components/cvcards/cvcard";
import { Card, Col, Dropdown, Row } from "react-bootstrap";
import Input from "../../components/input/input";
import Phone from "../../assets/icons/phone.png";
import Mail from "../../assets/icons/mail.png";
import EditIcon from "../../assets/svg/pencil.svg";
import "./style.css";
import CvLocation from "./location/cv-location";
import Compensation from "./compensation/compensation";
import Employement from "./employement/employement";
import Internship from "./internship/internship";
import Events from "./events/events";
import InternshipPreference from "./internship-preference/internship-preference";
import AboutMe from "./about-me/about-me";
import Skills from "./skills/skills";
import Education from "./education/education";
import {
  getProfileDetails,
  getSchoolListing,
  getSchoolsCourses,
  getTalentprofileview,
  getmycvuserdatails,
  updategetmycvuserdatails,
  getDataWorkPersonality,
  getTalentUserData,
  getTalentOceanReport,
  getTalentOceanReportSchool,
  getDataWorkValues
} from "../../services/apiCalls";
import { onBoardFormGetData } from "../../services/apiCalls";
import PhoneInput from "react-phone-number-input";
import CustomButton from "../../components/button/button";
import { toast } from "react-toastify";
import { ImageWrapper } from "../analyticalDashboardPage/commonStyles";
import { useNavigate } from "react-router-dom";
import MyCvPreview from "./my-cv-preview/my-cv-preview";
import { isValidObject } from "../../utilities/validators";
import { getResumeData } from "../../services/apiCalls";
import { useDispatch, useSelector } from "react-redux";
// import { setResumeData } from "../../../Redux/Reducers/ProfileReducer/ProfileReducer"
import { setResumeData } from "../../Redux/Reducers/ProfileReducer/ProfileReducer";
import { userDetailsUpdate } from "../../services/apiCalls";
import detailimage from "../../assets/avatar.png";
import { useTranslation } from "react-i18next";
import { resetFilter } from "../internship/reducer"; //INIVOS
import MyCvAssesment from "./mycvassesment";
import Toggle from "./Toggle";
import Button from "../../components/button/button";
import VisibilityCVPopup from "../../components/visibilityPopup/visibilityPopup";
import { ModalHeaderTextThree } from "../../components/alertModal/indexComponents";
import Loader from "../../components/loader/loader";
import { from } from "rxjs";
import MyCvAssesmentSecondary from "./myCVAssessmentSecondary";

const PageTitle = styled.h1`
  margin: 30px 50px 10px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 20px 12px 10px;
  }
`;
const PageWrapper = styled.div`
  min-height: 80vh;
  padding: 0rem 3rem;
  @media (max-width: 767px) {
    padding: 0rem 0.8rem;
  }
`;
const PropertyText = styled.div`
  font-family: "General Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 180%;
  color: #d04c8d;
  width: 200px;
  display: table-cell;
  @media (max-width: 599px) {
    display: block;
    width: auto;
  }
`;
const ValueText = styled.div`
  font-family: "General Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 180%;
  color: #6b6b6b;
  display: table-cell;
  @media (max-width: 599px) {
    display: block;
    margin-bottom: 8px;
    overflow-wrap: anywhere;
  }
`;
const RecommendedJobsCard = styled.div`
  background-color: white;
  margin-bottom: 30px;
  border-radius: 10px;
  padding: 3%;
  cursor: pointer;
`;

const ResumeName = styled.div`
  font-size: 20px;
  font-family: "General Sans";
  font-weight: 600;
  position: relative;
  @media (max-width: 599px) {
    text-align: center;
    margin: 10px 0 15px;
  }
`;
const ProfileAvatarWrapper = styled.div`
  @media (max-width: 599px) {
    display: flex;
    justify-content: center;

    /* shared ImageWrapper is a fixed 220px box with the avatar at its left,
       so shrink it to the avatar or the picture sits off-centre */
    > div {
      width: auto;
    }
  }
`;

const ProfileAddressOuter = styled.div`
  display: flex;
  @media (max-width: 599px) {
    display: block;
  }
`;
const ProfileAddress = styled.div`
  display: flex;
  @media (max-width: 599px) {
    flex-wrap: wrap;
  }
`;

const SalaryWrapper = styled.div`
  display: flex;
  @media (max-width: 599px) {
    flex-direction: column;
    padding: 30px 20px 0;

    /* drop the desktop offsets so label and input stack inside the card */
    > div {
      position: static;
      margin: 0;
    }
    > div + div {
      width: 100%;
      margin-top: 10px;
    }
    input {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
  }
`;
// plain block on desktop. On mobile the toggle keeps its size and the label
// wraps instead of running under it (e.g. the longer Malay translation)
const InvisibleWrapper = styled.div`
  @media (max-width: 599px) {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px 20px 0;

    > div {
      position: static;
      margin: 0;
    }
    > div:first-child {
      flex: 1;
      min-width: 0;
    }
    > div:last-child {
      flex-shrink: 0;
    }

    /* ToggleSwitch.css lifts the pill with bottom: 40px and the hidden
       checkbox still takes a line, so undo both to centre it with the label */
    .toggles {
      position: relative;
    }
    .toggles > input {
      position: absolute;
    }
    .toggles > label {
      bottom: 0;
      margin: 0;
    }
  }
`;

const CardContainer = styled.div`
  margin-top: 4%;
`;

const FormGroup = styled.div`
  margin-bottom: 25px;
  @media (max-width: 599px) {
    margin-bottom: 10px;
    margin-top: 1.5rem;
  }
`;

const Icon = styled.img`
  height: 18px;
  width: 18px;
`;

const ResumeOnlyme = styled.div`
  display: -webkit-box;
  float: right;
`;

const EllipsisWrapper = styled.div`
  display: flex;
  justify-content: right;
  padding-top: 20px;
  padding-right: 20px;
  cursor: pointer;
`;

const Elipsis = styled.div`
  height: 6px;
  width: 6px;
  background-color: #aaaaaa;
  border-radius: 50%;
  display: inline-block;
`;
const DropdownList = styled.span`
  padding-left: 10px;
  font-family: General Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #202020;
`;

const EmailContainer = styled.div`
  font-family: General Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #525252;
  padding-top: 10px;
`;

const EducationDegree = styled.div`
  font-family: General Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #d04c8d;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const EducationCYear = styled.div`
  font-family: General Sans;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */
  color: #525252;
`;

const StrengthWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const DashboardWrapper = styled.div`
  @media (max-width: 1024px) {
    display: flex;
  }
`;

const HamburgerLayout = styled.div`
  @media (min-width: 1024px) {
    display: none;
  }
`;
const StudentImage = styled.div`
background-image: ${(props) => `url(${props.profile_picture})` } ; 
background-position: center center;
background-repeat: no-repeat;
background-size: cover;
padding-bottom: 100%;
position: relative;
width: 100%;
border-radius: 50% !important;
max-width: 100%;
height: auto;
`;
const LabelText = styled.div`
  font-family: "General Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #202020;
  position: relative;
  top: 30px;
  left: 200px;
  margin: 10px 0 30px 0;
  @media (min-width: 320px) and (max-width: 480px) {
    position: relative;
    top: 30px;
    left: 0px;
    margin: 10px 9px 30px 20px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    position: relative;
    top: 30px;
    left: 82px;
    margin: 10px 0 30px 0;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    font-family: "General Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #202020;
    position: relative;
    top: 30px;
    left: 100px;
    margin: 10px 0 30px 0;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    font-size: 18px;
    line-height: 24px;
    color: #202020;
    position: relative;
    top: 30px;
    left: 118px;
    margin: 10px 0 30px 0;
  }
`;
const CardWrapper = styled.div`
  background: #ffffff;
  border-radius: 10px;
  height: 173px;
  margin: 20px 50px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 10px 12px;
    height: 270px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    height: 250px;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    height: 250px;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    height: 250px;
  }
`;
const CardWrapper2 = styled.div`
  background: #ffffff;
  border-radius: 34px;
  // height: 173px;
  margin: 20px 50px;
  padding: 20px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 10px 12px;
    height: 270px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    height: 250px;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    height: 250px;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    height: 250px;
  }
`;
const StatusText = styled.div`
  font-family: "General Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 115.5%;
  // text-decoration-line: underline;
  color: #504f8c;
  position: relative;
  left: 400px;
  top: 10px;
  @media (min-width: 320px) and (max-width: 480px) {
    position: relative;
    display: flex;
    justify-content: center;
    left: 10px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    position: relative;
    top: 10px;
    display: flex;
    left: auto;
    justify-content: center;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    position: relative;
    top: 10px;
    display: flex;
    justify-content: center;
    left: auto;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    position: relative;
    display: flex;
    justify-content: center;
    left: auto;
  }
`;
const MainDiv = styled.div`
  position: relative;
  left: 220px;
  top: 30px;
  width: 300px;
  @media (min-width: 320px) and (max-width: 480px) {
    width: auto;
    left: auto;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    position: relative;
    left: 157px;
    top: 30px;
    width: 300px;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    position: relative;
    left: 168px;
    top: 30px;
    width: 300px;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    position: relative;
    left: 180px;
    top: 30px;
    width: 300px;
  }
`;
 const StyledDarkerCard = styled.span`
  background: #f8f8f8;
  border-radius: 54px;
`;
 const StyledDarkerCardCustom = styled(StyledDarkerCard)`
  align-items: center;
  background-color: #f1f3f4;
  border-radius: 100px;
  box-sizing: border-box;
  display: inline-flex;
  max-height: none;
  min-height: 48px;
  padding-left: 17px;
  padding-right: 17px;
  position: relative;
  font-family: General Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #525252;
  color: #525252;
  margin: 0px 20px 20px 0px;

  svg {
    margin-right: 10px;
  }
`;

const MainToggle = styled.div`
  position: relative;
  left: 470px;
  bottom: 15px;
  @media (min-width: 320px) and (max-width: 480px) {
    position: relative;
    left: 200px;
    bottom: 15px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    position: relative;
    left: 400px;
    bottom: 15px;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    position: relative;
    left: 419px;
    bottom: 15px;
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    position: relative;
    left: 415px;
    bottom: 15px;
  }
`;
const StudentDetailsWrapper = styled.span`
  display: block;
  &.label,
  .value {
    font-family: General Sans;
    font-style: normal;
    font-weight: normal;
    display: inline-block;
    font-size: 18px;
    line-height: 24px;
    margin-right: 15px;
    margin-bottom: 8px;
  }
  .label {
    color: #202020;
    font-weight: 700;
  }
  .value {
    color: #d04c8d;
    font-weight: 500;
  }
`;
const SaveDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  gap: 20px;
  top: -112px;
  left: 100px;
  @media (min-width: 320px) and (max-width: 480px) {
    position: relative;
    top: -23%;
    left: 0;
    button {
      width: 121px;
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    position: relative;
    display: flex;
    justify-content: center;
    top: -23%;
    left: 0;
    button {
      width: 121px;
    }
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    position: relative;
    display: flex;
    justify-content: center;
    top: -23%;
    left: 0;
    button {
      width: 121px;
    }
  }
  @media (min-width: 1025px) and (max-width: 1200px) {
    position: relative;
    display: flex;
    justify-content: center;
    top: -23%;
    left: 0;
    button {
      width: 121px;
    }
  }
`;
export const BoxWrapper = styled.div`
background: #FDFDFD;
border: 1px solid rgba(228, 228, 228, 0.26);
border-radius: 10px;
padding:24px 42px;
margin:20px auto;
@media (max-width: 500px) {
    padding:16px;
}
`;
export const SubHeading = styled.p`
font-family: 'General Sans';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 180%;
color: #D04C8D;

`;

export const SubjectTitle = styled.p`

font-family: 'General Sans';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;

color: #000000;


`
;
export const StudentName = styled.div`
font-family: 'General Sans';
font-style: normal;
font-weight: 600;
font-size: 20px;
margin: 20px;
line-height: 28px;

color: #000000;

`
export const SubjectCard = styled.div`

display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 8px 16px;
gap: 8px;
margin-right: 5px;
background: #D04C8D;
border-radius: 8px;

/* Add Maths */


/* Body/Base text */
font-family: 'General Sans';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;

color: #FFFFFF;

`;
const useStyles = Mui.makeStyles((theme) => ({
  avatarStyle: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    borderRadius: 100,
  },
}));

const initialDisplay = {
  internshipPref: false,
  employment: false,
  location: false,
  compensation: false,
  aboutMe: false,
  internship: false,
  events: false,
  education: false,
  strengths: false,
  motivated: false,
  workValues: false,
  tests: false,
  customSkills: false,
  skills: false,
};

export default function MyCV() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [mblNumber, setMblNumber] = useState("");
  const [disableContact, setDisableContact] = useState(true);
  const [profileDetails, setProfileDetails] = useState(null);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [display, setDisplay] = useState(initialDisplay);
  const [isMyCvDownLoad, setIsMyCvDownLoad] = useState(false);
  const [downloadingComplete, setDownloadingComplete] = useState(false);
  const [handleCvPrint, setHandleCvPrint] = useState(false);
  const talentData = useSelector((state) => state?.talent?.userData);
  const [onBoardFormDetails, setOnBoardFormDetails] = useState(null);
  const [openVisibilityModal,setOpenVisibilityModal] = useState(false);
  const [coreSubjectsValues, setCoreSubjectsValues] = useState();
  const [electiveSubjectsValues, setElectiveSubjects] = useState();
  const [isOpenham, setOpenHam] = useState(false);
  const [salerylist, setSalerylist] = useState([
    { label: "2000 RM", value: "2000" },
    { label: "2500 RM", value: "2500" },
  ]);
  const [salery, setSalery] = useState("none");
  const [saleryQuery, setSaleryQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(saleryQuery);
  const [visiable, setVisiable] = useState("Y");
  const [saleryOne, setSaleryOne] = useState("");
  const [visiableOne, setVisiableOne] = useState("Y");
  const [viewcount, setViewcount] = useState(0);
  const [schoolName, setSchoolName] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    //INIVOS
    dispatch(resetFilter());

    fetchProfileDetails();
    fetchOnBoardFormDetails();
    setDisplayFlags();
    
    return () => {
      setDisplay({ ...initialDisplay });
    };
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedQuery(saleryQuery);
    }, 500); // 500ms debounce time, you can adjust this

    // Clean up the timeout if the effect is called again (if the user keeps typing)
    return () => {
      clearTimeout(timerId);
    };
  }, [saleryQuery]);
  useEffect( async () => {
    // if (debouncedQuery.trim()) {  // Only make the API call if there is non-empty text
      // API call function
      if(salery != 'none'){
        updategetmycvuserdatails("salery", { salery: saleryQuery });

      }    // }
  }, [debouncedQuery]);


  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const setDisplayFlags = () => {
    let flag = {
      internshipPref: true,
      employment: true,
      location: true,
      compensation: true,
      aboutMe: true,
      internship: true,
      events: true,
      education: true,
      strengths: true,
      motivated: true,
      workValues: true,
      tests: true,
      customSkills: true,
      skills: true,
    };
    setDisplay(flag);
  };

  const notification = (type, message) => {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const fetchProfileDetails = async () => {
    const { data, status } = await getProfileDetails();
    if (status === 200 && data.status === 1) {
      setProfileDetails(data.data);
    }
  };

  const talentprofileview = async () => {
    const { data, status } = await getTalentprofileview();
    
    if (status === 200 && data.status === 1) {
      if (data.data && data.data.profile_views) {
        setViewcount(data.data.profile_views);
      } else {
        setViewcount(0);
      }
    }
  };
  const fetchOnBoardFormDetails = async () => {
    const { data, status } = await onBoardFormGetData();
    if (status === 200 && data.status === 1) {
      if (data.data.insti_location_status === 0) {
        data.data.insti_name_abbr = data.data.university;
      } else {
        data.data.university = "";
      }
      setOnBoardFormDetails(data.data);
    }
  };
  const onNavigate = (route) => {
    navigate(route);
  };

  const [mobile_number, setMobileNumber] = useState("");
  const formValues = useSelector((state) => state.selfIntroOne.value);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState("");

  const imageBaseData = useSelector((state)=> state.imageBase64.imageBaseData);
  const [workPersonalityData, setWorkPersonalityData] = useState([]);
  const [facetData, setFacetData] = useState([]);
  const [orgFitData, setOrgFitData] = useState([]);
  const [personalityAspectData, setPersonalityAspectData] = useState([]);
  const [reliabilityData, setReliabilityData] = useState([]);
  const [competencyData, setCompetencyData] = useState([]);
  const [workValuesData, setWorkValuesData] = useState([]);
  const [schoolCourses, setSchoolCourses] = useState([]);
  const [courseType,setCourseType] = useState("");

  const getDataPersonality = async (id) => {
    const { data } = await getDataWorkPersonality(id);
    if (data?.status === 1) {
      var datasLabel = [];
      var datasValue = [];
      var datasColor = [];

      if(Array.isArray(data?.data) && data.data.length === 0){
        
        setWorkPersonalityData({data:[],status:"noDataFound"});
        return;
      }

      Object.keys(data?.data).map((e, i) => {
        datasLabel.push(t(e));
        datasValue.push(data?.data[e]["points"]);
        var x = Math.floor(Math.random() * 256);
        var y = 25 + Math.floor(Math.random() * 256);
        var z = 50 + Math.floor(Math.random() * 256);
        datasColor.push("rgb(" + x + "," + y + "," + z + ",0.5)");
      });

      setWorkPersonalityData(data?.data);
    }
  };

  const getOceanReport = async (id) => {
      const { data } = await (
            formValues.talent_status === "school_student"
              ? getTalentOceanReportSchool(id)
              : getTalentOceanReport(id)
          );
      if (data?.status === 1) {
        const OCEANData = data?.data?.data[0];
        setFacetData(OCEANData["30 - Facets"]);
        setOrgFitData(OCEANData["Organizational Fit Factor"]);
        setPersonalityAspectData(OCEANData["Personality Aspects"]);
        setReliabilityData(OCEANData["Predictive Reliability Factor"]);
        setCompetencyData(OCEANData["Work Competency Factor"]);
      }
    };

  

    const getDataValue = async (id) => {
        const { data } = await getDataWorkValues(id);
        if (data?.status === 1) {
          var datasLabel = [];
          var datasValue = [];
          var datasColor = [];
          var datasValues = [];
          if(Array.isArray(data?.data) && data?.data.length === 0){
            setWorkValuesData({data:[],status:"noDataFound"});
          }else{
            Object.keys(data?.data).map((e, i) => {
              datasLabel.push(t(e));
              datasValue.push(data?.data[e]["points"]);
              datasValues.push(data?.data[e]["values"]);
      
              var x = Math.floor(Math.random() * 256);
              var y = 25 + Math.floor(Math.random() * 256);
              var z = 50 + Math.floor(Math.random() * 256);
              datasColor.push("rgb(" + x + "," + y + "," + z + ",0.5)");
            });
            setWorkValuesData(data?.data);
          }
        }
      };

      const getUser = async () => {
        const { data } = await getTalentUserData();
    
        if (data && data.status === 1) {
          let id = data.data.id;
          await getDataValue(id);
          await getDataPersonality(id);
          await getOceanReport(id);
        }
      };

    useEffect(() => {
          getUser();   
      }, []);

      const Openness = workPersonalityData['Openness to Experience']?.points;
    const Agreeableness = workPersonalityData['Agreeableness']?.points;
    const Extraversion = workPersonalityData['Extraversion']?.points;
    const Conscientiousness = workPersonalityData['Conscientiousness']?.points;

    function normalizeBetween0To5(val) {
      var newMin = 0;
      var newMax = 5;
      var oldMin = 0;
      var oldMax = 120;
      var newVal = newMin + (((val - oldMin) * (newMax - newMin)) / (oldMax - oldMin))
      return Math.round(newVal * 100) / 100;
  };

  const LearningStyleContent =[
    {
        title: 'Visual & Kinesthetic',
        description: 'Learners with a preference for the combined Visual and Kinesthetic style grasp concepts more effectively through direct interaction with learning materials. They thrive on engaging physically with tasks and benefit from the use of visual aids.',
        points: [
            'Engaging with interactive simulations and physical models.',
            'Using diagrams, flowcharts, and illustrative videos to understand complex concepts.',
            'Participating in workshops where they can physically manipulate relevant materials.',
        ],
        score: ((normalizeBetween0To5(Openness) + normalizeBetween0To5(Agreeableness)) / 2).toFixed(2)
    },
    {
        title: 'Aural',
        description: 'Aural learners absorb information best when it is presented verbally. They excel in environments where listening and discussion are encouraged and are adept at remembering spoken instructions.',
        points: [
            'Benefiting from lectures, group discussions, and verbal briefings.',
            'Using podcasts and audio recordings for learning new content.',
            'Participating in study groups or team meetings where ideas are discussed aloud.',
        ],
        score: normalizeBetween0To5(Extraversion)
    },
    {
        title: 'Reading & Writing',
        description: 'Read / Write learners prefer to interact with information through written words. They excel in traditional study methods involving reading and taking detailed notes',
        points: [
            'Using textbooks, articles, and written handouts as primary study materials.',
            'Making comprehensive lists, writing out notes, and summarizing information.',
            'Preferring email and text-based communication for clarity and record-keeping.',
        ],
        score: normalizeBetween0To5(Conscientiousness)
    }
]


  const onSubmit = (data) => {
    getUpdatedUserDetails(data);
    setDisableContact(true);
    setLoading(true);
  };

  const getUpdatedUserDetails = async ({ name, phone }) => {
    const { data, status } = await userDetailsUpdate({
      name: profileDetails?.display_name,
      phone_number:
        mobile_number === "" ? profileDetails?.mob_number : mobile_number,
    });
  };

  const cancelOverview = () => {
    setDisableContact(true);
  };

  const downloadComplete = (data) => {
    // debugger; 
    // setIsMyCvDownLoad(false)
    setDownloadingComplete(true);
    setHandleCvPrint(false);
  };

  if (downloadingComplete) {
    setTimeout(() => setIsMyCvDownLoad(false), 4000);
  }

  useEffect(async () => {
   await fetchSchoolCourses();
   await fetchSchools();
    await talentprofileview();
    async function fetchResumeData() {
      const response = await getResumeData();
      if (
        isValidObject(response) &&
        response.hasOwnProperty("data") &&
        response.data !== undefined &&
        response.hasOwnProperty("status")
      ) {
        //dispatch to store the response in redux
        dispatch(setResumeData(response.data.data));
      }
    }
    fetchResumeData();
    getmycydetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangePhone = (value) => {
    if (value) {
      setMobileNumber(value);
    }
    setProfileDetails({ ...profileDetails, mob_number: value });
  };

  const getUniName = (
    talent_status,
    insti_country_status,
    insti_location_status,
    insti_name,
    university
  ) => {
    //returns true if study locally, false if study abroad
    if (talent_status === "studying" || talent_status === "internship") {
      if (insti_location_status === 1) {
        //study locally
        return true;
      } else {
        //study abroad
        return false;
      }
    } else if (talent_status === "employed" || talent_status === "unemployed") {
      console.log("insti_country_status", insti_country_status);
      console.log("insti_location_status", onBoardFormDetails);
      console.log("university", onBoardFormDetails.university);
      if (insti_country_status === 1) {
        //study locally
        return true;
      } else {
        //study abroad
        return false;
      }
    } else {
      return false;
    }
  };

  const getmycydetails = async () => {
    let data = await getmycvuserdatails();
    if (data.status == 200) {
      // setSalery(data.data.data.salery);
      setSaleryQuery(data.data.data.salery);

      setVisiable(data.data.data.visible);
      setVisiableOne(data.data.data.visible);
    }
  };

  console.log("talentDataProfile",formValues)
  const changesalery = async (v) => {
    // setSalery(v)
    setSaleryOne(v);
  };
  const funChange = async () => {
    // await updategetmycvuserdatails("salery", { salery: saleryOne });
    await updategetmycvuserdatails("visible", { visible: visiableOne });

    await getmycydetails();
  };
  const funccan = (async) => {
    // setSaleryOne(salery);
    setVisiableOne(visiable);
  };
  const changevisiable = async () => {
    let a = "";
    if (visiableOne == "Y") {
      a = "N";
      setVisiableOne("N");
      setOpenVisibilityModal(true);
    } else {
      a = "Y";
      setVisiableOne("Y");
      setOpenVisibilityModal(true);

    }
  };
  function onCloseVisibilityPopup(){
    setOpenVisibilityModal(false);
  }
  const { t } = useTranslation();
  // redirect to dashboard if has not completed assessment
  const completion = useSelector((state) => {
    return state.profile.profilePercentage;
  });
  const content = () => {
    return (
      <>
        {/* <Form
          onSubmit={handleSubmitBulk(onBulkUpload)}
          encType="multipart/form-data" */}
        {/* > */}
          <ModalHeaderTextThree>
             {visiableOne === "N" ? "Your CV is not visible to Company" : "Your CV is now visible to Company"}
          </ModalHeaderTextThree>
      
          <Row>
            {loading ? (
              <Loader />
            ) : (
              <Col
                md="12"
                className="d-flex justify-content-center align-items-center"
              >
                <Button
                  width="100px"
                  margin="40px 0px 30px 0px"
                  onClick={()=>{
                    funChange();
                    onCloseVisibilityPopup(false);

            }}
                  name={t("Save")}
                  // type="submit"
                />
                <Button
                  secondary
                  color="#FFFFFF"
                  name={t("Cancel")}
                  style={{
                    margin: "40px 5px 30px 10px",
                  }}
                  variant="outlined"
                  onClick={()=>{
                    funccan();
                    onCloseVisibilityPopup(false);
                  }}
                ></Button>
              </Col>
            )}
          </Row>
        {/* </Form> */}
      </>
    );
  };
  const getCurrentForm = (formVal) => {
    switch(formVal){
      case 1 || "1":
        return `${t("Form")} 1`
      case 2 || "2":
        return `${t("Form")} 2`
      case 3 || "3":
        return `${t("Form")} 3`
      case 6 || "6":
        return `${t("Form")} 6`
      case 4 || "4" :
        return `${t("Form")} 4`
      case 5 || "5":
        return `${t("Form")} 5`
      default:
        return "-"
    }
    }
  // if ((completion != null) & (completion < 100)) {
  //   navigate("/dashboard");
  // }

    const fetchSchools = async () => {
      const { data, status } = await getSchoolListing();
      if (status === 200) {
          console.log("schoolListing",data)
        const schoolsList = data.data;
        const school_list = schoolsList.map((x) => {
          return { ...x, label: x.Name, value: x.Id };
        });
  
  
        if(formValues && formValues.school_id){
          console.log("schoolIds",formValues.school_id)
          const selectedSchool = school_list.find((val) =>  Number(val.value ) === Number(formValues.school_id) );
          setSchoolName(selectedSchool)
        }
      //   if (formVal.curr_study_year) {
      //     let selCurrstudyyear = Year_Of_Studies.filter(
      //       (x) => x.value == formVal.curr_study_year
      //     );
      //     if (selCurrstudyyear.length > 0) {
      //       selCurrstudyyear = selCurrstudyyear[0];
      //       setValue("curr_study_year", selCurrstudyyear.value);
      //     }
      //     setSchoolName(selCurrstudyyear);
      //   }
      }
    };  
  const fetchSchoolCourses = async () => {
    const { data, status } = await getSchoolsCourses();
    if (status === 200) {
        console.log("schoolListing",data.data)

        console.log("formValuesData",formValues.current_form)
        let subject = [];
        if(formValues.current_form >= 1 && formValues.current_form <= 3){
           subject = data.data.filter(course => course.course_type.includes(1));
           setCourseType("Elective Subject(s) Form 1-3")
        } else if(formValues.current_form >= 4 && formValues.current_form <= 5){
          subject = data.data.filter(course => course.course_type.includes(2));
           setCourseType("Elective Subject(s) Form 4-5")
        } else if(formValues.current_form === 6){
          setCourseType("Form 6 Subject(s)")
          subject = data.data.filter(course => course.course_type.includes(3));
        }
        console.log("subjectList",formValues.elective_subjects,subject)
     const filteredSubject =   subject.filter((val) =>  formValues.elective_subjects.includes(val?.id))
console.log("filterList",filteredSubject)
        setSchoolCourses(filteredSubject);

//         let core_subjects = data.data.filter(course => course.course_type === 0);
// let elective_subjects = data.data.filter(course => course.course_type === 1);
// core_subjects = core_subjects.map((x) => {
//   return { ...x, label: x.course_name, value: x.id };

// });
// console.log("coreSubject",core_subjects)
// elective_subjects = elective_subjects.map((x) => {
//   return { ...x, label: x.course_name, value: x.id };

// });

// setCoreSubjectLisitng(core_subjects);
// setElectiveSubjectListing(elective_subjects);
 
// if(formValues && formValues.elective_subjects){
//   console.log("formValLLL",formValues.elective_subjects)
//   const electiveSubjects = elective_subjects.filter((val) =>  formValues.elective_subjects.includes(val?.id))
//   console.log("filterList",electiveSubjects)
//   setElectiveSubjects(electiveSubjects)
// }
// if(formValues && formValues.core_subjects){
//   console.log("formValLLL",formValues.core_subjects)
//   const electiveSubjects = core_subjects.filter((val) =>  formValues.core_subjects.includes(val?.id))
//   console.log("filterList",electiveSubjects)
//   setCoreSubjectsValues(electiveSubjects)
// }


    }
  };

  return (
    <>
      <MainLayout>
        <PageTitle className="header">
          {t("My CV")}
        </PageTitle>
        {formValues.talent_status === "school_student"?
        <>
        <CardWrapper2>
        <Row>
        <Col lg="3">
        <StudentImage  profile_picture={    talentData?.profile_picture
                        ? talentData?.profile_picture
                        : detailimage} className="ratio img-fluid rounded-circle" />

                      </Col>
        <Col lg="9">
            <Row style={{justifyContent:"space-between"}}>

            <Col >
            <StudentName>{formValues?.full_name}</StudentName>

            </Col> 

              <Col className="d-flex justify-content-end align-items-center">
                <div style={{ paddingRight: "10px" }}>
                  {(<Button name={t("Download")} onClick={() => {
                                          setIsMyCvDownLoad(true);

                    // props.downloadCallback();
                    // setIsMyCvDownLoad(true);
                    // setLoader(true);

                  }} />)}

                </div>
                {/* <Button name={t("Schedule Meeting")} onClick={onOpen} /> */}
              </Col>
            </Row>
          
          {/* <Row>
            <Col>
              <MainTitle>{props.talentData.display_name}</MainTitle>
            </Col>
            <Col className="d-md-none d-lg-block" />
            {props.backButtonEnable &&
              <Col className="d-flex justify-content-end align-items-center">
                <CounsellingRecords onClick={onButtonClicked}>{t("View counselling records")}</CounsellingRecords>
              </Col>
            }
          </Row> */}
          <Row>
            <Col xs="12">
              <hr />
            </Col>
          
           {formValues.current_form != 6 && <Col xs="12">
          
              <StyledDarkerCardCustom>  {t("SPM Year") + ": " } {formValues.spm_year ?? '-'}</StyledDarkerCardCustom>
            
              {/* <StyledDarkerCardCustom>{props.talentData.id_number}</StyledDarkerCardCustom> */}
            </Col>}
            <Col xs="12">
              <StudentDetailsWrapper>
                <span className="label">{t("School Name")}:</span>{" "}
                <span className="value">{schoolName.Name ?? '-'}</span>
              </StudentDetailsWrapper>
            { formValues.current_form != 6 &&  <StudentDetailsWrapper>
                <span className="label">{t("SPM Year")}:</span>{" "}
                <span className="value">{formValues.spm_year ?? '-'}</span>
              </StudentDetailsWrapper>}
              <StudentDetailsWrapper>
                <span className="label">{t("Current Form")}:</span>{" "}
                <span className="value">{getCurrentForm(formValues.current_form)}</span>
              </StudentDetailsWrapper>
              {/* <StudentDetailsWrapper>
                <span className="label">{t("Grade")}:</span>{" "}
                <span className="value">{props.talentData.cgpa}</span>
              </StudentDetailsWrapper> */}
            </Col>
          
         
            {/* {props.userOverallData.internship_details?.length > 0 &&
              <>
                <Row>
                  <Col>
                    <CardHeaderTitle >{t("Internship Details")}</CardHeaderTitle>
                  </Col>
                </Row>
                {props.userOverallData.internship_details.map((internship, index) => (
                  <Col xs="12" md="6" key={index}>
                    <div style={{ display: "block", padding: "0.5em", margin: "0.5em 0", boxShadow: "0px 1.61407px 4.84221px rgba(13, 10, 44, 0.08)", borderRadius: "16px" }}>
                      <StudentDetailsWrapper>
                        <span className="label">{t("Organization")}:</span>{" "}
                        <span className="value">{internship.organization}</span>
                      </StudentDetailsWrapper>
                      <StudentDetailsWrapper>
                        <span className="label">{t("Title")}:</span>{" "}
                        <span className="value">{internship.job_title}</span>
                      </StudentDetailsWrapper>
                      <StudentDetailsWrapper>
                        <span className="label">{t("Start Date")}:</span>{" "}
                        <span className="value">{internship.start_date}</span>
                      </StudentDetailsWrapper>
                      <StudentDetailsWrapper>
                        <span className="label">{t("End Date")}:</span>{" "}
                        <span className="value">{internship.end_date}</span>
                      </StudentDetailsWrapper>
                    </div>
                  </Col>
                ))}
            
              </>
            } */}
          </Row>
        </Col>
<Col lg="12">
<BoxWrapper>
        <SubHeading style={{ fontSize: "18px" }}>
              {t("Subjects")}
            </SubHeading>
            <hr />
<SubjectTitle>{t(`${courseType}`)}</SubjectTitle>
<div className="d-flex">
  {schoolCourses?.length > 0 ?
  <>
  {
    schoolCourses?.map((item)=><SubjectCard>{t(item?.course_name)}</SubjectCard>)
  }
  </>: <></>}
</div>



        </BoxWrapper>
</Col>
<MyCvAssesmentSecondary />
      </Row>
        </CardWrapper2>
        </>
        : <>
           <CardWrapper>
          {/* <StatusText>{`You have ${viewcount} profile view`}</StatusText> */}
          <SalaryWrapper>
            <LabelText>{t("My expected salary")}</LabelText>
            <MainDiv>
              <Input
                placeholder={t("Enter salary")}
                name="salary"
                type="number"
                value={saleryQuery}
                onChange={(val) => {
                  setSalery("added")
                  setSaleryQuery(val.target.value)}}              />
            </MainDiv>
          </SalaryWrapper>
          <InvisibleWrapper>
            <LabelText>{t("Make me invisible")}</LabelText>
            <MainToggle>
              <Toggle data={visiableOne} onClick={changevisiable} />
            </MainToggle>
          </InvisibleWrapper>
          {/* <SaveDiv>
            {salery !== saleryOne || visiable !== visiableOne ? (
              <>
                <Button name="Save" onClick={funChange} />
                <Button name="Cancel" onClick={funccan} />
              </>
            ) : (
              ""
            )}
          </SaveDiv> */}
        </CardWrapper>
        <PageWrapper>
          <DashboardWrapper>
            <HamburgerLayout>
              <HamburgerLay toggled={isOpenham} toggle={setOpenHam} />
            </HamburgerLayout>
            {isOpenham && <Menus onClose={() => setOpenHam(false)} />}
          </DashboardWrapper>
          <RecommendedJobsCard>
            <div id="cv-loader">
              <div className="loader-container">
                <div className="common-loader">
                  <div className="spinner">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
                </div>
              </div>
            </div>
            <EllipsisWrapper>
              <Dropdown className="dropdown__toggle">
                <Dropdown.Toggle variant="">
                  <Elipsis />
                  &nbsp;
                  <Elipsis />
                  ;
                  <Elipsis />
                </Dropdown.Toggle>
                <Dropdown.Menu className=" font-family-general-sans-medium">
                  {/* <Dropdown.Item onClick={() => setHandleCvPrint(true)}>
                    Print
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    onClick={() => {
                      setIsMyCvDownLoad(true);
                    }}
                  >
                    {t("Download")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </EllipsisWrapper>

            <Row>
              <Col lg={2}>
                <ProfileAvatarWrapper>
                  <ImageWrapper>
                    <Mui.Avatar
                      src={
                        talentData?.profile_picture
                          ? talentData?.profile_picture
                          : detailimage
                      }
                      alt="Profile pic"
                      className={classes.avatarStyle}
                    />
                  </ImageWrapper>
                </ProfileAvatarWrapper>
              </Col>
              <Col lg={10}>
                <>
                  <ResumeName>{profileDetails?.full_name}</ResumeName>
                </>
                <div style={{ display: "table" }}>
                  <div style={{ display: "table-row" }}>
                    <PropertyText>{t("Scope of Study") + " :"}  </PropertyText>
                    <ValueText>{profileDetails?.scope_abbr} </ValueText>
                  </div>
                </div>
                <div style={{ display: "table" }}>
                  <div style={{ display: "table-row" }}>
                    <PropertyText>{t("Education Institution") + " :"}  </PropertyText>
                    <ValueText>
                      {onBoardFormDetails?.talent_status === "army" ? "N/A" : getUniName(
                        onBoardFormDetails?.talent_status,
                        onBoardFormDetails?.insti_country_status,
                        onBoardFormDetails?.insti_location_status,
                        onBoardFormDetails?.insti_name_abbr,
                        onBoardFormDetails?.university
                      )
                        ? onBoardFormDetails?.insti_name_abbr
                        : onBoardFormDetails?.university}
                    </ValueText>
                  </div>
                </div>
                <div style={{ display: "table" }}>
                  <div style={{ display: "table-row" }}>
                    <PropertyText>{t("Address") + " :"}  </PropertyText>
                    <ProfileAddressOuter>
                      <ValueText>
                        <ProfileAddress>
                          <div style={{ marginRight: "5px" }}>
                            {profileDetails?.city_abbr},
                          </div>
                          <div style={{ marginRight: "5px" }}>
                            {profileDetails?.state_abbr},
                          </div>
                          <div style={{ marginRight: "5px" }}>
                            {profileDetails?.curr_country_abbr}
                          </div>
                          <div>{profileDetails?.postalcode}</div>
                        </ProfileAddress>
                      </ValueText>
                    </ProfileAddressOuter>
                  </div>
                </div>
                <div style={{ display: "table" }}>
                  <div style={{ display: "table-row" }}>
                    <PropertyText>{t("Primary e-mail id") + " :"} </PropertyText>
                    <ValueText>{profileDetails?.email} </ValueText>
                  </div>
                </div>
                <div style={{ display: "table" }}>
                  <div style={{ display: "table-row" }}>
                    <PropertyText>{t("Primary mobile no") + " :"}</PropertyText>
                    <ValueText>
                      {mobile_number === ""
                        ? profileDetails?.mob_number
                        : mobile_number}
                    </ValueText>
                  </div>
                </div>
                <br />{" "}
              </Col>
            </Row>

            
            <CardContainer>
              <Row>
                <CvCard
                  title={t("Employment Details")}
                  titleColor={Colors.primaryText}
                  showLock={true}
                >
                  {display.employment && (
                    <Employement notification={notification} />
                  )}
                </CvCard>
              </Row>
            </CardContainer>
            <CardContainer>
              <Row style={{ padding: "0px" }}>
                <Col md="6" style={{ padding: "0px" }}>
                  <CvCard
                    title={t("Location")}
                    titleColor={Colors.primaryText}
                    showLock={true}
                  >
                    {display.location && (
                      <CvLocation notification={notification} />
                    )}
                  </CvCard>
                </Col>
                <Col md="6">
                  <CvCard
                    title={t("Compensation")}
                    titleColor={Colors.primaryText}
                    showLock={true}
                  >
                    {display.compensation && (
                      <Compensation notification={notification} />
                    )}
                  </CvCard>
                </Col>
              </Row>
            </CardContainer>

            <CardContainer>
              <Row>
                {display.aboutMe && <AboutMe notification={notification} />}
              </Row>
            </CardContainer>

            <CardContainer>
              <Row>
                <CvCard
                  title={t("Internship")}
                  titleColor={Colors.primaryText}
                  showLock={true}
                >
                  {display.internship && (
                    <Internship notification={notification} />
                  )}
                </CvCard>
              </Row>
            </CardContainer>

            <CardContainer>
              <Row>
                <CvCard
                  title={t("Event")}
                  titleColor={Colors.primaryText}
                  showLock={true}
                >
                  {display.events && <Events notification={notification} />}
                </CvCard>
              </Row>
            </CardContainer>

            <CardContainer>
              <Row>
                <CvCard
                  title={t("Education")}
                  titleColor={Colors.primaryText}
                  showLock={true}
                >
                  {display.education && (
                    <Education notification={notification} />
                  )}
                </CvCard>
              </Row>
            </CardContainer>

            {/* <CardContainer>
            <Row>
              <Col md="6">
                <CvCard title="Strengths" titleColor={Colors.primaryText} showLock={true}>
                  {display.strengths && <TextInput>User has not attempted the test.</TextInput>}
                </CvCard>
              </Col>
              <Col md="6">
                <CvCard title="Motivated By" titleColor={Colors.primaryText} showLock={true}>
                  {display.motivated && <TextInput>User has not attempted the test.</TextInput>}
                </CvCard>
              </Col>
            </Row>
          </CardContainer>
          <CardContainer>
            <Row>
              <Col md="6">
                <CvCard title="Work Values" titleColor={Colors.primaryText} showLock={true}>
                  {display.workValues && <TextInput>You have not added any work value.</TextInput>}
                </CvCard>
              </Col>
            </Row>
          </CardContainer>

          <CardContainer>
            <Row>
              <CvCard title="Test and Assessments" titleColor={Colors.primaryText} showLock={true}>
                {display.tests && <TestAssessments />}
              </CvCard>
            </Row>

          </CardContainer>
          */}
            <CardContainer>
              <Row>
                <Col md="12">
                  <CvCard
                    title={t("Custom Skills")}
                    titleColor={Colors.primaryText}
                    showLock={true}
                  >
                    {display.customSkills && <Skills />}
                  </CvCard>
                </Col>
                {/*   <Col md="6">
                <CvCard title="Skills" titleColor={Colors.primaryText} showLock={true}>
                  {display.skills && <TextInput>To declare career please <Anchor>click here</Anchor></TextInput>}
                </CvCard>
              </Col> */}
              </Row>
              <MyCvAssesment />
            </CardContainer>
          </RecommendedJobsCard>
        </PageWrapper>
        </>}
     
      </MainLayout>
      <VisibilityCVPopup
         title={"My CV"}
         subTitle={"Update Visibility Status"}
         show={openVisibilityModal}
         close={onCloseVisibilityPopup}
         content={content()}
      >
        
      </VisibilityCVPopup>
      {isMyCvDownLoad && (
        <div style={{ height: "0", display: "hidden" }}>
          <MyCvPreview
            talentStatus={formValues}
            talentData={formValues}
            coreSubjects={coreSubjectsValues}
                courseType={courseType}
            electiveSubjects={schoolCourses}
            isMyCvDownLoad={isMyCvDownLoad}
            downloadComplete={downloadComplete}
            handleCvPrint={false}
            schoolName={schoolName.Name}
            imageBaseData={imageBaseData}
            ocean={{
              workCompetency: competencyData,
              personalityAspect: personalityAspectData,
              thirtyFacets: facetData,
              predictiveReliability: reliabilityData,
            }}
            learningStyle={LearningStyleContent}
          />
        </div>
      )}
      {handleCvPrint && (
        <div style={{ height: "0", display: "hidden" }}>
          <MyCvPreview
    talentStatus={formValues}
    talentData={formValues}
    coreSubjects={coreSubjectsValues}
    courseType={courseType}
    electiveSubjects={schoolCourses}            isMyCvDownLoad={false}
            downloadComplete={downloadComplete}
            handleCvPrint={handleCvPrint}
            schoolName={schoolName.Name}
            imageBaseData={imageBaseData}
            ocean={{
              workCompetency: competencyData,
              personalityAspect: personalityAspectData,
              thirtyFacets: facetData,
              predictiveReliability: reliabilityData,
            }}
            learningStyle={LearningStyleContent}
          />
        </div>
      )}
    </>
  );
}
